import React from "react";
import Editor from "@monaco-editor/react";
import { data } from "../utils/Languages";
import { Modal, Button } from "react-bootstrap";
import { escapeRegex } from "../utils/CommonFunctions";
import { toast } from "react-toastify";
import { FiPlayCircle, FiSave } from "react-icons/fi";
import { BiEnvelopeOpen } from "react-icons/bi";
import { HiSwitchHorizontal, HiOutlineDocumentDownload } from "react-icons/hi";
import { IoCopyOutline } from "react-icons/io5";
import { DropdownButton, Dropdown } from "react-bootstrap";
import { HotKeys } from "react-hotkeys";

class Home extends React.Component {
  state = {
    source: "",
    language_id: 53,
    saveModal: false,
    savedModal: false,
    fileName: "",
    savedCodes: [],
    search: "",
    editor_code: "cpp",
    theme: "dark",
    fontSize: "14px",
  };

  // lifecycle
  componentDidMount = () => {
    console.log(data);
    var language = localStorage.getItem("language");
    if (language) {
      this.setState({ language_id: Number(language) });
    } else {
      language = this.state.language_id;
      localStorage.setItem("language", this.state.language_id);
    }
    var fontSize = localStorage.getItem("fontSize");
    if (fontSize) {
      console.log(fontSize);
      this.setState({ fontSize: fontSize });
    } else {
      fontSize = this.state.fontSize;
      localStorage.setItem("fontSize", this.state.fontSize);
    }
    this.setState({
      source: data.filter((item) => item.id === Number(language))[0].code,
    });
    const theme = JSON.parse(localStorage.getItem("theme"));
    if (theme) {
      this.setState({ theme });
    }
  };

  // lifecycle
  componentWillReceiveProps = (props) => {
    console.log("herer", Number(props.language_id));
    this.setState({
      language_id: Number(props.language_id),
      editor_code: data.filter(
        (item) => item.id === Number(props.language_id)
      )[0].editor_code,
    });
    if (props.change) {
      this.setState({
        source: data.filter((item) => item.id === Number(props.language_id))[0]
          .code,
      });
      props.changeLanguage(props.language_id, false);
    }
  };

  // close modal
  handleClose = () => {
    this.setState({ saveModal: !this.state.saveModal });
  };

  // close save modal
  handleCloseSaved = () => {
    this.setState({ savedModal: !this.state.savedModal });
  };

  // save code
  changeSource = (e) => {
    // console.log(e);
    this.setState({ source: e });
  };

  // fetch saved code
  fetchSavedCode = () => {
    var localData = JSON.parse(localStorage.getItem("codes")) || [];
    this.setState({ savedCodes: localData, savedModal: true });
  };

  // set state of language and code
  setCode = (item) => {
    this.setState({
      language_id: item.language,
      source: item.code,
      savedModal: false,
    });
    this.props.changeLanguage(item.language, false);
  };

  // set state of search
  handleSearch = (e) => {
    // console.log(e.target.value);
    this.setState({ search: e.target.value });
  };

  // searching using regex
  checkSearch = (pName) => {
    const regExp = new RegExp(escapeRegex(this.state.search), "i");
    return regExp.test(pName);
  };

  // delete the saved code
  deleteCode = (index) => {
    var data1 = this.state.savedCodes;
    console.log(data1);
    if (window.confirm("Are you sure you want to Delete this code?")) {
      // Save it!
      console.log("Thing was saved to the database.");
      if (data1.length > 1) {
        data1.splice(index, 1);
      } else {
        data1 = [];
      }
      console.log(data1);
      this.setState({ savedCodes: data1 });
      localStorage.setItem("codes", JSON.stringify(data1));
    } else {
      // Do nothing!
      console.log("Thing was not saved to the database.");
    }
  };

  // copy code
  copyCode = () => {
    navigator.clipboard.writeText(this.state.source);
    toast.info("Code copied to clipboard");
  };

  // download code
  downloadTxtFile = () => {
    const element = document.createElement("a");
    const file = new Blob([this.state.source], { type: "text/plain" });
    element.href = URL.createObjectURL(file);
    if (this.state.editor_code === "java") {
      element.download = `main.${this.state.editor_code}`;
    } else {
      element.download = `code.${this.state.editor_code}`;
    }
    document.body.appendChild(element); // Required for this to work in FireFox
    element.click();
  };

  // save code to local storage
  saveFile = () => {
    var localData = JSON.parse(localStorage.getItem("codes")) || [];
    const data = {
      code: this.state.source,
      language: this.state.language_id,
      name: this.state.fileName,
    };
    localData.push(data);
    localStorage.setItem("codes", JSON.stringify(localData));
    this.setState({ fileName: "", saveModal: false });
    toast.info("Saved", {
      autoClose: 2000,
      hideProgressBar: true,
      closeOnClick: false,
      pauseOnHover: false,
      draggable: false,
      progress: undefined,
    });
  };

  // change font size
  changeFontSize = (size) => {
    this.setState({ fontSize: size.value });
    localStorage.setItem("fontSize", size.value);
  };

  // change theme
  changeTheme = (e) => {
    this.setState({ theme: e });
    localStorage.setItem("theme", JSON.stringify(e));
  };

  render() {
    const sizes = [
      { value: "10px" },
      { value: "14px" },
      { value: "16px" },
      { value: "18px" },
      { value: "20px" },
      { value: "22px" },
    ];
    if (this.state.source.length > 0) {
      window.addEventListener("beforeunload", (ev) => {
        ev.preventDefault();
        return (ev.returnValue = "Are you sure you want to close?");
      });
    }
    const keyMap = {
      runCode: ["ctrl+enter", "command+enter"],
      saveCode: ["ctrl+s", "command+s"],
    };
    const handlers = {
      runCode: () => {
        this.props.runProgram(this.state.source);
      },
      saveCode: () => {
        this.setState({ saveModal: true });
      },
    };
    return (
      <HotKeys keyMap={keyMap} handlers={handlers} allowChanges={true}>
        <div className="row">
          <div className="d-flex justify-content-start">
            <button
              className="btn btn-run m-2 d-flex align-items-center"
              onClick={() => {
                this.props.runProgram(this.state.source);
              }}
              disabled={this.props.running}
            >
              <FiPlayCircle size="20px" className="mr-2" />
              {this.props.running ? "Running" : "Run"}
            </button>
            <button
              className="btn btn-primary m-2 d-flex align-items-center"
              onClick={() => this.setState({ saveModal: true })}
            >
              <FiSave size="20px" className="mr-2" />
              Save
            </button>
            <button
              className="btn btn-primary m-2 d-flex align-items-center"
              onClick={() => this.copyCode()}
            >
              <IoCopyOutline size="20px" className="mr-2" />
              Copy
            </button>
            <DropdownButton
              id="dropdown-button-dark-example2"
              variant="primary"
              menuVariant="dark"
              title={"More Options"}
              className="m-2"
            >
              <Dropdown.Item onClick={() => this.downloadTxtFile()}>
                <HiOutlineDocumentDownload size="20px" className="mr-2" />
                Download
              </Dropdown.Item>
              <Dropdown.Item onClick={this.fetchSavedCode}>
                <BiEnvelopeOpen size="20px" className="mr-2" />
                View Saved Codes
              </Dropdown.Item>
              <Dropdown.Item
                onClick={() =>
                  this.changeTheme(
                    this.state.theme === "dark" ? "light" : "dark"
                  )
                }
              >
                <HiSwitchHorizontal size="20px" className="mr-2" />
                Switch Editor Theme
              </Dropdown.Item>
            </DropdownButton>
            <DropdownButton
              id="dropdown-button-dark-example2"
              variant="primary"
              menuVariant="dark"
              title={"Font Size"}
              className="m-2"
            >
              {sizes.map((size, index) => (
                <Dropdown.Item
                  key={index}
                  onClick={() => this.changeFontSize(size)}
                  active={this.state.fontSize === size.value}
                >
                  {size.value}
                </Dropdown.Item>
              ))}
            </DropdownButton>
          </div>
        </div>
        <Editor
          height="85vh"
          language={this.state.editor_code}
          theme={`vs-${this.state.theme}`}
          options={{
            fontSize: this.state.fontSize,
          }}
          value={this.state.source}
          onChange={this.changeSource}
        />
        <Modal
          show={this.state.saveModal}
          onHide={this.handleClose}
          style={{ color: "rgb(30 30 30)" }}
        >
          <Modal.Header closeButton>
            <Modal.Title>Save Code</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <input
              className="form-control"
              placeholder="Enter File Name"
              value={this.state.fileName}
              onChange={(e) => {
                this.setState({ fileName: e.target.value });
              }}
            ></input>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleClose}>
              Close
            </Button>
            <Button
              variant="primary"
              onClick={this.saveFile}
              disabled={this.state.fileName === ""}
            >
              Save
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal
          show={this.state.savedModal}
          onHide={this.handleCloseSaved}
          style={{
            color: "rgb(30 30 30)",
          }}
        >
          <Modal.Header closeButton>
            <Modal.Title>Saved Codes</Modal.Title>
          </Modal.Header>
          <Modal.Body
            style={{ overflowY: "scroll", maxHeight: "calc(100vh - 210px)" }}
          >
            {this.state.savedCodes.length === 0 ? (
              <div className="text-center">
                <img src="https://42f2671d685f51e10fc6-b9fcecea3e50b3b59bdc28dead054ebc.ssl.cf5.rackcdn.com/v2/assets/empty.svg" />
                <h6 className="mt-3">No results found</h6>
              </div>
            ) : (
              <>
                <input
                  className="form-control"
                  placeholder="search"
                  type="search"
                  value={this.state.search}
                  onChange={(e) => this.handleSearch(e)}
                ></input>
                {this.state.savedCodes.map(
                  (item, index) =>
                    this.checkSearch(item.name) && (
                      <div className="row pt-3">
                        <div className="col-7">
                          <h6>{item.name}</h6>
                        </div>
                        <button
                          className="btn btn-primary col-2 mr-2"
                          onClick={() => {
                            this.setCode(item);
                          }}
                        >
                          Open
                        </button>
                        <button
                          className="btn btn-danger col-2"
                          onClick={() => {
                            this.deleteCode(index);
                          }}
                        >
                          Delete
                        </button>
                      </div>
                    )
                )}
              </>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseSaved}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </HotKeys>
    );
  }
}

export default Home;
